<div class="container-fluid">
    <div class="row">
        <div class="col-12" *ngIf="summaryMode">
            <u>{{disclosureName}}</u>
        </div>
        <div class="col-12" *ngIf="!summaryMode">
            <u class="ais-disclosure-name">{{disclosureName}}</u>
            <button type="button" class="close" aria-label="Close"
                    *ngIf="onRemove && isRemovable()" (click)="onRemoveClick()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
    <div class="row mt-2" *ngIf="httpErrorMsg">
        <div class="col-12 alert alert-danger">
            {{httpErrorMsg}}
        </div>
        
    </div>
</div>
